class SGiftCardRecipient extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const toggle = this.querySelector('[data-recipient-toggle]');
    if (!(toggle instanceof HTMLInputElement)) return;

    toggle.addEventListener('change', () => this.#sync(toggle), { signal: this.#ac.signal });
    this.#sync(toggle);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync(toggle) {
    const on = toggle.checked;
    const fields = this.querySelector('[data-recipient-fields]');
    if (fields instanceof HTMLElement) fields.hidden = !on;
    toggle.setAttribute('aria-expanded', String(on));

    for (const input of this.querySelectorAll('[data-recipient-input]')) {
      input.disabled = !on;
    }

    const email = this.querySelector('[data-recipient-email]');
    if (email instanceof HTMLInputElement) email.required = on;
  }
}

if (!customElements.get('s-gift-card-recipient')) {
  customElements.define('s-gift-card-recipient', SGiftCardRecipient);
}
